import { defineStore } from "pinia";
import Api from "src/utils/api";
import Constants from "@/utils/constants";

export const useEmployeeStore = defineStore("employee_store", {
  persist: true,
  state: () => ({
    employeeList: []
  }),
  actions: {
    async getEmployeeList(config) {
      let _res = await Api.Employee.getEmployeeList(
        Constants.enums.TABLES_NAME_ENUM.EMPLOYEE_TABLE,
        config
      );

      this.employeeList = _res.data || [];
      return _res.data || [];
    }
  },
  $reset() {}
});
